import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MyBetsState } from "./my-bets.reducers";

export const getMyBetsState = createFeatureSelector<MyBetsState>("myBets");

export const getMyBetsTickets = createSelector(getMyBetsState, (state: MyBetsState) => state.myBetsTickets);
